module.exports = __webpack_public_path__ + "@/assets/img/tools.fa63ed93.svg";